import { useState } from "react";
import { IChart } from "../../../../../@types/chart.type";
import dayjs from "dayjs";
import iconDelete from "./../../../../../assets/_TrashIcon_gray.svg";
import { GridBaseWidget } from "../../GridBaseWidget";
import { ColDef, IGetRowsParams } from "ag-grid-community";
import { getAllNonScheduledResource } from "../../../../../services/api/widgets/widgetsService";
import { IApiResponse } from "../../../../../@types/api-response.type";
import { storageUserGet } from "../../../../../storage/storageUser";
import { AllNonScheduledResourceDto } from "../../../../../@types/widgets.type";
import { IconCompanyIdleness } from "../../../../../icons/IconCompanyIdleness";
import { CustomCellRendererProps } from "ag-grid-react";
import styles from "./styles.module.scss";

interface MyTeamIdlenessProps {
  chart: IChart;
  ismodeEdit: boolean;
  deleteChart: (id: string | undefined, widgetId: string) => void;
  rowHeightGrid: number;
}

const columns: ColDef[] = [
  {
    field: "id",
    headerName: "ID",
    hide: true,
  },
  {
    field: "resourceName",
    headerName: "Nome",
    flex: 1,
  },
  {
    field: "managerName",
    headerName: "Gestor",
    flex: 1,
  },
  {
    field: "nonScheduled",
    headerName: "Horas não alocadas",
    cellRenderer: (params: CustomCellRendererProps) => {
      return `${params.value}h`;
    },
    flex: 1,
  },
];

export function MyTeamIdleness({
  chart,
  deleteChart,
  ismodeEdit,
}: MyTeamIdlenessProps) {
  const [loading, setLoading] = useState<boolean>(false);

  const user = storageUserGet();

  async function fetchMyTeamIdleness(params: IGetRowsParams) {
    const paramsBody = {
      managerId: user?.resourceId as string,
      startTime: dayjs().startOf("month").format("YYYY-MM-DD"),
      endTime: dayjs().endOf("month").format("YYYY-MM-DD"),
      skip: params.startRow, // Linha inicial para paginação
      take: params.endRow - params.startRow, // Quantidade de linhas
    };

    try {
      setLoading(true);
      const response = (await getAllNonScheduledResource(
        paramsBody
      )) as IApiResponse<AllNonScheduledResourceDto>;

      if (response.statusCode === 200) {
        params.successCallback(
          response.result.nonScheduledResource,
          response.result.nonScheduledResourceCount
        );
      }
    } catch (error) {
      console.log(error);
      params.failCallback();
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.widget}>
      <div className={styles.header}>
        <h3>
          <IconCompanyIdleness size={24} />
          Ociosidade da Minha Equipe no Mês
        </h3>
      </div>
      <div style={{ width: "100%", height: "100%" }}>
        <GridBaseWidget
          columns={columns}
          fetchData={fetchMyTeamIdleness}
          loading={loading}
        />
      </div>
      {ismodeEdit && (
        <button onClick={() => deleteChart(chart.id, chart.widgetId)}>
          <img src={iconDelete} alt="" />
        </button>
      )}
    </div>
  );
}
